import { styled, css } from 'styled-components';
export const GroupWrapper = styled.div `
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns}, 1fr);
  background-color: ${({ theme }) => theme.colors.grey00_1};

  & > *:not(:nth-child(${({ $columns }) => $columns}n + 1)) {
    border-left: 1px solid ${({ theme }) => theme.colors.grey10_1};
  }
  & > *:nth-child(n + ${({ $columns }) => $columns + 1}) {
    border-top: 1px solid ${({ theme }) => theme.colors.grey10_1};
  }

  ${({ $rounded, theme }) => $rounded &&
    css `
      border: 1px solid ${theme.colors.grey10_1};
      border-radius: 8px;
      overflow: hidden;
    `}
`;
export const ItemWrapper = styled.div `
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  word-break: break-word;

  ${({ $columnSpan }) => $columnSpan &&
    css `
      grid-column: span ${$columnSpan};
    `}
`;
export const Header = styled.div `
  color: ${({ theme }) => theme.colors.grey100_1};
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: ${({ $headline }) => ($headline ? 'space-between' : 'flex-end')};
  flex-direction: ${({ $headline }) => ($headline ? 'row' : 'row-reverse')};
`;
export const IconWrapper = styled.div `
  padding: 6px;
  display: inline-flex;
  border-radius: 50%;
  background-color: ${({ $iconBackgroundColor }) => $iconBackgroundColor};
`;
export const Indicator = styled.span `
  width: 12px;
  height: 12px;
  border: 2px solid ${({ $color }) => $color};
  border-radius: 50%;
`;
export const TextValue = styled.p `
  white-space: pre;
  margin: 0;
`;
export const Content = styled.div `
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
export const Row = styled.div `
  display: flex;
  gap: 4px;
`;
export const Label = styled.div `
  width: 120px;
  min-width: 100px;
  color: ${({ theme }) => theme.colors.grey100_1};
`;
export const Value = styled.div `
  flex-grow: 1;
  white-space: pre;
`;
